<div class="sz-page-title">
  <div class="sz-page-title__kicker">
    <ng-content select="[szTitleKicker]" />
  </div>
  <div class="sz-page-title__row">
    @if (showBack()) {
      <button type="button" class="sz-page-title__back" (click)="onBackClick()" [attr.aria-label]="backAriaLabel()">
        <sz-icon name="arrow-back" [size]="20" />
      </button>
    }
    <h2 class="sz-page-title__title" [class.sz-page-title__title--xl]="size() === 'xl'">
      {{ title() }}
      @if (accent(); as accentText) {
        <span class="sz-page-title__accent"> {{ accentText }}</span>
      }
    </h2>
    @if (actionItems().length > 0) {
      <sz-action-menu [items]="actionItems()" [ariaLabel]="actionsAriaLabel()" (itemSelect)="onActionSelect($event)" />
    }
  </div>
  <div class="sz-page-title__sub">
    <ng-content select="[szTitleSub]" />
  </div>
</div>
